import { useCallback, useEffect, useState } from "react";
import {
  getFavorites,
  toggleFavorite,
  removeFavorite,
  clearFavorites,
} from "../../../utils/favorites";

export const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [ready, setReady] = useState(false);

  const sync = useCallback(() => {
    setFavorites(getFavorites());
  }, []);

  useEffect(() => {
    sync();
    setReady(true);

    const onUpdate = () => sync();
    window.addEventListener("favorites:updated", onUpdate);
    window.addEventListener("storage", onUpdate);
    return () => {
      window.removeEventListener("favorites:updated", onUpdate);
      window.removeEventListener("storage", onUpdate);
    };
  }, [sync]);

  const toggle = (product) => {
    const nowFav = toggleFavorite(product);
    sync();
    return nowFav;
  };

  const remove = (producto_id) => {
    removeFavorite(producto_id);
    sync();
  };

  const clear = () => {
    clearFavorites();
    sync();
  };

  const isFav = (producto_id) =>
    favorites.some((f) => f.producto_id === producto_id);

  return {
    favorites,
    ready,
    count: favorites.length,
    toggle,
    remove,
    clear,
    isFav,
  };
};

export default useFavorites;
